import Model, { attr } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';

export type DocumentType = 'drivers-license' | 'passport' | 'id-card';

type DocumentImage = {
  'image-type': 'document-front' | 'document-back';
  content: string;
};

export default class IdScanSession extends Model {
  declare [Type]: 'id-scan-session';

  @attr('string') declare firstName: string;
  @attr('string') declare lastName: string;
  @attr('string') declare documentType: DocumentType;
  @attr('date') declare timestamp: Date;
  @attr() declare images: DocumentImage[];
}
